import { useState } from "react";

export const useDataManagementPagination = () => {
  const [pageIndex, setPageIndex] = useState(0);
  const [after, setAfter] = useState<string | null>(null);
  const [before, setBefore] = useState<string | null>(null);

  const DEFAULT_ROWS = 10;

  const handleNextPage = (endCursor?: string) => {
    setBefore(null);
    setAfter(endCursor || null);
    setPageIndex(pageIndex + 1);
  };

  const handlePreviousPage = (startCursor?: string) => {
    setAfter(null);
    setBefore(startCursor || null);
    setPageIndex(pageIndex - 1);
  };

  const getPaginationConfig = () => ({
    first: after || (!after && !before) ? DEFAULT_ROWS : undefined,
    after: after || undefined,
    before: before || undefined,
  });

  return {
    pageIndex,
    after,
    before,
    DEFAULT_ROWS,
    handleNextPage,
    handlePreviousPage,
    getPaginationConfig,
  };
};
